export enum Length {
  KM = 'km',
  MILES = 'miles',
}
